@let isAssistantOrHigher = isAssistantOrHigher$ | async;
<div class="o-page">
    <div class="o-grid">
        <div class="o-grid__col">
            <div class="o-grid">
                <div class="o-grid__row"></div>
                <div class="o-grid__row">
                    <div class="o-grid__item">
                        <h1>{{ checkEditStatus() }}</h1>
                    </div>
                </div>
                <div class="o-grid__row">
                    <div class="o-grid__item">
                        @if (isEditStudy) {
                            <medpace-study
                                (detailsChangeEvent)="registerStudyDetailsChange($event)"
                                (logoChangeEvent)="registerLogoChange($event)"
                                (studyInfoChangeEvent)="registerStudyInfoChange($event)"
                                (studyRegionsChange)="registerStudyRegionChange($event)"
                                (studyCountriesChange)="registerStudyCountryChange($event)"
                                (studyTravelOptionsChange)="registerStudyTravelOptionChange($event)"
                                (submitClickEvent)="updateExistingStudy($event)"
                                [isAdmin]="isAssistantOrHigher"
                                [isUpdate]="isEditStudy"
                                [study]="study"
                                (uploadSpreadsheetClickedEvent)="uploadSpreadsheetClicked()"
                                (addNewSiteClickedEvent)="addNewSiteClicked()"
                                (siteRowClickedEvent)="siteRowClicked($event)"
                            >
                                @if (studyThresholdsPermissions.read()) {
                                    <medpace-study-payment-approval-threshold-card
                                        [thresholdResource]="studyThresholds"
                                        [studyId]="id()"
                                        [mode]="'view'"
                                        [isLoading]="studyThresholds.isLoading()"
                                        [showEditSaveButton]="studyThresholdsPermissions.edit()"
                                        [formGroup]="studyThresholdsFormGroup"
                                        [model]="studyThresholds.value()"
                                    />
                                }
                            </medpace-study>
                        } @else if (!isEditStudy && this.clintrakContext) {
                            <medpace-study
                                (detailsChangeEvent)="registerStudyDetailsChange($event)"
                                (logoChangeEvent)="registerLogoChange($event)"
                                (studyInfoChangeEvent)="registerStudyInfoChange($event)"
                                (studyRegionsChange)="registerStudyRegionChange($event)"
                                (studyCountriesChange)="registerStudyCountryChange($event)"
                                (studyTravelOptionsChange)="registerStudyTravelOptionChange($event)"
                                (submitClickEvent)="submitNewStudy($event)"
                                (approveStudy)="approveStudy()"
                                (rejectStudyEvent)="rejectClinTrakStudy()"
                                [isAdmin]="isAssistantOrHigher"
                                [isUpdate]="isEditStudy"
                                [study]="study"
                                (uploadSpreadsheetClickedEvent)="uploadSpreadsheetClicked()"
                                (addNewSiteClickedEvent)="addNewSiteClicked()"
                                (siteRowClickedEvent)="siteRowClicked($event)"
                            >
                            </medpace-study>
                        } @else if (!isEditStudy && !this.clintrakContext) {
                            <medpace-alert
                                [appearance]="'danger'"
                                [content]="'You can not create Study without ClinTrak data.'"
                            />
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
